<template>
  <div class="page">
    <router-view></router-view>
  </div>
</template>

<script>
import api from "@/apis/api";

export default {
  name: "App",
  data: function () {
    return {
      domain: ""
    }
  },
  mounted: function () {
    this.domain = window.location.hostname.split(".").length >= 3 ? window.location.hostname.split(".")[window.location.hostname.split(".").length - 3] : "";
    this.getCity();
  },
  methods: {
    getCity: function () {
      var _this = this;
      var data = {
        domain: _this.domain
      };
      api.getCity(data).then(function (response) {
        window.document.title = response.responseData.name + "宠物殡葬";
      });
    }
  }
}
</script>

<style scoped>

</style>
